import { Link } from "react-router-dom";
import { useEffectiveRole } from "../../../lib/roles";
import { useOnboarding } from "../lib/OnboardingProvider";

/** AppShell setup-incomplete banner. Owner/Admin + Manager/Trainer only.
 * Never blocks navigation. Fails silently on state errors. */
export function SetupIncompleteBanner() {
  const role = useEffectiveRole();
  const { state } = useOnboarding();
  const visibleRole = role === "owner_admin" || role === "manager_trainer" || role === "super_admin";
  if (!visibleRole) return null;
  if (!state) return null;
  if (state.overall_status === "completed") return null;
  return (
    <div role="status" data-testid="setup-incomplete-banner"
      className="border-b border-amber-200 bg-amber-50 px-4 py-2 text-sm text-amber-900 dark:border-amber-900 dark:bg-amber-950 dark:text-amber-200">
      CRM setup is incomplete ({state.completion_pct}% complete).{" "}
      <Link to="/onboarding" className="underline" data-testid="setup-incomplete-link">
        Review the onboarding checklist
      </Link>.
    </div>
  );
}
